import { render, staticRenderFns } from "./itemName.vue?vue&type=template&id=32b875f6&"
var script = {}
import style0 from "./itemName.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports